import clsx from "clsx";
import type {PropsWithChildren} from "react";

import type {HeadlineVariantProps} from "~/components/Headline/headlineVariants.ts";
import { headlineVariants} from "~/components/Headline/headlineVariants.ts";

type HeadlineProps = HeadlineVariantProps & {
	color?: string;
	colorClassName?: string;
	className?: string;
	id?: string;
}

const Headline: React.FC<PropsWithChildren<HeadlineProps>> = ({
	children,
	colorClassName,
	type = "h1",
	color,
	size,
	weight,
	className,
	id
}) => {
	const Element = type;
	const colorName = colorClassName ? "none" : color;

	return <Element className={clsx(headlineVariants({type, size, color: colorName, weight}), colorClassName,
		className)} id={id}>{children}</Element>;
};

export default Headline;
